module.exports = __webpack_public_path__ + "assets/images/pointer_c8719a6aba47ab89ead91d509d521ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chroma-pointer/pointer.png
// module id = 145
// module chunks = 0